module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticStyle: {
      "background": "#ffffff",
      "width": "100%",
      "height": "4.5em",
      "top": "0",
      "position": "fixed",
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #e7e7e7",
      "display": "inline",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "32px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin": "5px 1em",
      "color": "#000000"
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "text-align": "center",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.path))]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-size": "24px",
      "cursor": "pointer",
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-853b6adc"}!./src/pages/MainHeader/template.html
// module id = 267
// module chunks = 0